module.exports = __webpack_public_path__ + "img/no_data.c9c29d55.svg";